<template>  

  <div class='row m-0'>

    <div class='col-md-12' v-if='fetchingFullFeed || errorFullFeed'>
      <div class='fetch-feed-spinner' v-if="fetchingFullFeed"> 
        <i class='fa fa-spinner fa-spin fa-4x'></i>
      </div>

      <div v-if='errorFullFeed' class='error-fetching-container'>
        <div>Error loading photos</div>
        <div class="reload-btn bg-warning" @click="reloadWindow()">
          Try Again
        </div>
      </div>      
    </div>

    <div class='col-xl-7 col-xl-offset-1 col-md-8 col-md-offset-1'>
      <photo-card-legacy
        v-for="photo in photos" 
        :key='photo.id'
        @like="likePost"
        @unlike="unLikePost"
        @comment="commentOnPhoto"
        @approved-photo="approvedPhoto"
        @denied-photo="deniedPhoto"
        v-bind:requiresApproval="requiresApproval"
        v-bind:canManage="canManage"
        v-bind:photo="photo"
        v-bind:eventAttendee="eventAttendee"
        v-bind:apiAuthToken="apiAuthToken"
        v-bind:eventId="eventId"
        v-bind:streamId="streamId"
        v-bind:base-url="baseUrl"
        v-bind:is-web="isWeb"
      >
      </photo-card-legacy>
      <div class='show-more-btn btn-primary' @click="getBeforeFeed()" v-if="!this.fetchingBeforeFeed && this.hasMoreFeed">
        <span class='show-more-text'>
          Show More
        </span>
      </div> 
      <div class='show-more-spinner' v-if="this.fetchingBeforeFeed && !fetchingFullFeed && !errorFullFeed">
        <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
      </div>
    </div>
    <div class='col-md-3'>

      <div class="show-modal-btn themePrimaryColorBackgroundSolid" ref='showModalBtn' @click="openModal()" v-if="this.initialized">
        <i class='fa fa-plus themeSecondaryColor'></i>
        <span class='themeSecondaryColor'>{{ lang.get('event_strings.photo_stream.make_post') }}</span>
      </div>
    </div>
    <photo-stream-modal-legacy
      v-if='showModal'
      v-on:close="closeModal"
      v-bind:fetching="fetching.submittingPhoto"
    >
      <template #header>
        <div class='title'>
          {{ lang.get('event_strings.photo_stream.make_post')}}
        </div>
      </template>
      <template #body>
        <photo-form-legacy
          v-bind:eventAttendee="eventAttendee"
          v-bind:submittingPhoto="fetching.submittingPhoto"
          v-bind:api-auth-token='apiAuthToken'
          v-bind:event-id="eventId"
          v-bind:base-url="baseUrl"
          v-bind:camera-type="cameraType"
          @submit-file-post="submitFilePost"
          @submit-text-post="submitTextPost"
        >
        </photo-form-legacy>
      </template>

    </photo-stream-modal-legacy>
  </div>
</template>

<script>
import axios from 'axios';
var toastConfig = {
  type: 'success', 
  duration: 4000,
  position: 'bottom-right',
  action: {
    text: 'DISMISS',
    onClick: (e, toastObject) => {
      toastObject.goAway(0);
    }            
  }
}

export default {

  props: [
    "eventId", 
    'streamId', 
    'manage', 
    'apiAuthToken', 
    'attendee', 
    'eventAttendee', 
    'userAvatarUrl',
    'goToPost',
    'baseUrl',
    'isWeb'
  ],

  data() {
    return {
      fetching: {
        fullFeed: this.$fetchStates.fetching,
        beforeFeed: this.$fetchStates.fetching,
        afterFeed: this.$fetchStates.idle,
        submittingPhoto: this.$fetchStates.idle,
        approvingPhoto: this.$fetchStates.idle
      },
      showModal: false,
      newestRecordCreatedAt: null,
      oldestRecordCreatedAt: null,
      photos: [],
      photoPreview: null,
      hasMoreFeed: true,
      photoErrorMessage: 'Error uploading post',
      photoSuccessMessage: 'Your post has been created successfully',
      cameraType: 'photo_and_video',
      requiresApproval: false
    }
  },

  computed: {

    canManage () {
      return this.manage === '1'
    },

    fetchingBeforeFeed () {
      return this.fetching.beforeFeed === this.$fetchStates.fetching
    },

    fetchingFullFeed () {
      return this.fetching.fullFeed === this.$fetchStates.fetching
    },

    errorFullFeed () {
      return this.fetching.fullFeed === this.$fetchStates.error
    },

    initialized () {
      return this.fetching.fullFeed === this.$fetchStates.success
    }
  },

  methods: {

    closeModal () {
      this.showModal = false
    },

    openModal () {
      this.showModal = true
    },

    getFormattedURL(relativePath) {
      var url = relativePath

      if(this.isWeb != 'true') {
        url = `/events/${this.eventId}`+url
      }

      if ((typeof this.baseUrl === 'string' || this.baseUrl instanceof String) && this.baseUrl != '') {
        url = this.baseUrl+url
      }

      return url
    },
    
    fetchFeed () {
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/feed`);
     
      this.fetching.fullFeed = this.$fetchStates.fetching
        axios.get(url, {
          params: {
            api_auth_token: this.apiAuthToken, 
            manage: this.canManage,
          }
        })
        .then((response) => {
          this.photos = response.data.photos
          this.newestRecordCreatedAt = response.data.newest_record_created_at
          this.oldestRecordCreatedAt = response.data.oldest_record_created_at
          if (response.data.photos.length < 10) this.hasMoreFeed = false
          this.fetching.fullFeed = this.$fetchStates.success
          this.fetching.beforeFeed = this.$fetchStates.idle
          this.photoErrorMessage = response.data.error_message
          this.upload_success_message = response.data.upload_success_message
          this.cameraType = response.data.camera_type
          this.requiresApproval = response.data.requires_approval
          this.pollFeed()
          this.scrollToPost()
        }).catch((e) => {
          console.log("Error", e);
          this.fetching.fullFeed = this.$fetchStates.error
        })
    },

    scrollToTop () {
      setTimeout(() => {
        var contentBlock = document.getElementById('content-block')
        if (contentBlock) contentBlock.scrollTo({top: 0, behavior: 'auto' })
      },1 )

    },

    scrollToPost () {
      setTimeout(() => {
        var post = document.getElementById('photo-card-'+this.goToPost)
        if (post) post.scrollIntoView({behavior: "smooth"});
      },1 )

    },

    pollFeed () {
      setTimeout(() => {
        this.getAfterFeed()
        this.pollFeed()
      }, 20000)
    },

    getBeforeFeed () {

      if (this.fetchingBeforeFeed) return
       
      this.fetching.beforeFeed = this.$fetchStates.fetching

      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/more_feed`);
      
      axios.get(url, {
        params: {
          api_auth_token: this.apiAuthToken, 
          manage: this.canManage,
          datetime: this.oldestRecordCreatedAt
        }
      }).then((response) => {
        this.photos = [...this.photos, ...response.data.photos]
        this.oldestRecordCreatedAt = response.data.oldest_record_created_at
        if (response.data.photos.length < 10) this.hasMoreFeed = false
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.fetching.beforeFeed = this.$fetchStates.idle
      })

    },

    getAfterFeed () {
      this.fetching.afterFeed = this.$fetchStates.fetching

      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/new_feed`);

      axios.get(url, {
        params: {
          api_auth_token: this.apiAuthToken, 
          manage: this.canManage,
          datetime: this.newestRecordCreatedAt
        }
      }).then((response) => {
        var oldPhotos = response.data.photos.filter(photo => this.photos.find(foto => foto.id === photo.id))
        var newPhotos = response.data.photos.filter(photo => !this.photos.find(foto => foto.id === photo.id))
        this.photos = [...newPhotos, ...this.photos]
        this.photos = this.photos.map(obj => oldPhotos.find(o => o.id === obj.id) || obj);        
        if (response.data.newest_record_created_at) {
          this.newestRecordCreatedAt = response.data.newest_record_created_at
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => {
        this.fetching.afterFeed = this.$fetchStates.idle
      })
    },

    reloadWindow () {
      window.location.reload()
    },

    toastSuccessPostPhoto () {
      Vue.toasted.show(this.photoSuccessMessage, toastConfig);
    },

    toastErrorPostPhoto () {
      Vue.toasted.show(this.photoErrorMessage, Object.assign({}, toastConfig, {type: 'error'}));
    },

    submitTextPost (comment, userTags) {

      this.fetching.submittingPhoto = this.$fetchStates.fetching

      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/post_item`);

			axios({
        url: url,
        data: {
          api_auth_token: this.apiAuthToken,
          user_tags: userTags,
          comment: comment
        },
        method: 'post',
        responseType: 'json'
      })
      .then((res) => { 
        this.getAfterFeed()
        this.closeModal()
        this.scrollToTop()
        this.toastSuccessPostPhoto()
      })
      .catch((err) => { 
        console.log(err)
        this.toastErrorPostPhoto()
      }).finally(() => {
        this.fetching.submittingPhoto = this.$fetchStates.idle
      })      

    },

    submitFilePost (form, comment, userTags) {

      var formData = new FormData(form);
      if (comment) formData.append('comment', comment)
      if (userTags && userTags.length) formData.append('user_tags', userTags)
      this.fetching.submittingPhoto = this.$fetchStates.fetching

      var url = `/photo-streams/${this.streamId}/photos`
      if ((typeof this.baseUrl === 'string' || this.baseUrl instanceof String) && this.baseUrl != '') {
        url = this.baseUrl+`/photo-streams/${this.streamId}/photos`
      }

      axios({
        url: url,
        data: formData,
        method: 'POST'
      }).then((res) => {
        this.getAfterFeed()
        this.closeModal()
        this.scrollToTop()
        this.toastSuccessPostPhoto()
      }).catch((err) => {
        console.log(err)
        this.toastErrorPostPhoto()
      }).finally(() => {
        this.fetching.submittingPhoto = this.$fetchStates.idle
      })
    },
    
    commentOnPhoto (photo, comment) {
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${photo.id}/comments`);

      axios({
        url: url,
        data: {
          api_auth_token: this.apiAuthToken,
          comment: {
            comment
          }
        },
        method: 'POST',
        responseType: 'json'
      })
      .then((res) => {
        if (res.data && res.data.data && res.data.data.comments) {
          var updatedPhoto = this.photos.find((foto) => foto.id === photo.id)
          if (updatedPhoto) updatedPhoto.comments = res.data.data.comments
        }
      })
      .catch((err) => {
        console.log(err)
      })
    },

    likePost (photo, like) {
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${photo.id}/likes`); 

      axios({
        method: 'POST',
        url: url,
        data: { api_auth_token: this.apiAuthToken},
        responseType: 'json'
      }).then((res) => {
        if (res.data && res.data.like) {
          // should probably clean up endpoint, gives 200 even when does not create when one already exists,
          // dont know what else uses atm though
          const newLike = res.data.like
          if (photo.likes.find(like => like.id === newLike.id)) return
          var newPhoto = this.photos.find((foto) => foto.id === photo.id)
          newPhoto.likes.push(newLike)
        }
      }).catch((err) => { console.log(err) })
    },

    unLikePost (photo, like) {
      var url = this.getFormattedURL(`/photo-streams/${this.streamId}/photos/${photo.id}/likes/${like.id}`); 

      axios({
        method: 'DELETE',
        url: url,
        data: { api_auth_token: this.apiAuthToken},
        responseType: 'json'
      }).then((res) => {
        var newPhoto = this.photos.find((foto) => foto.id === photo.id)
        newPhoto.likes = photo.likes.filter((l) => l.id !== like.id)
        this.photos.forEach((foto) => {
          if (foto.id === newPhoto) foto = newPhoto
        })
      }).catch((err) => {
        console.log(err)
      })
    },

    approvedPhoto (photo) {
      this.photos.forEach((foto) => {
        if (foto.id === photo.id) {
          foto.approved = photo.approved
        }
      })
    },

    deniedPhoto (photo) {
      this.photos.forEach((foto) => {
        if (foto.id === photo.id) {
          foto.hidden = photo.hidden
        }
      }) 
    },

    addScrollListenerForRightAffix () {
      let ticking;
      let navHeight = 75 - 24
      const nav = document.getElementById('photostream-nav')
      if (nav) {
        navHeight = nav.offsetHeight - 24
      }

      const mobileNav = document.getElementsByClassName('mobile-navbar-external')[0]
      
      $('#content-block')[0].addEventListener('scroll', function(e) {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            var self = this

            var totalNavHeight = navHeight
            if (mobileNav) totalNavHeight + mobileNav.offsetHeight

            if (totalNavHeight < ($('#content-block').scrollTop())) {
              this.$refs.showModalBtn.style.position = 'fixed'
            } else {
              this.$refs.showModalBtn.style.position = ''
            }
            ticking = false;
          })
          ticking = true;
        }
      }.bind(this))
    }

  },

  mounted () {

    this.fetchFeed()
    
    this.$on('close', () => {
      this.showModal = false
    })
    this.addScrollListenerForRightAffix()

  }
};
</script>

<style scoped>

  .new-post-container {
  }

  .photo-preview {
    width: 50%;
  }

  .show-more-btn {
    width: 100%;
    margin-top: 2rem;
    margin-bottom: 2rem;
    padding: 1rem;
    border-radius: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .show-more-spinner {
    width: 100%;
    margin: 2rem;
    padding: 1rem;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }  

  .show-more-text {
    padding-right: 2rem;
  }

  .show-modal-btn {
    display: flex;
    justify-content: center;
    width: 14rem;
    padding: 1rem;
    margin-top: 2rem;
    top: 2rem;
    border-radius: 2.8rem;
    cursor: pointer;
  }
  
  .show-modal-btn > * {
    margin-left: 0.2rem;
    margin-right: 0.2rem;
  }

  .fetch-feed-spinner {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2rem;
  }

  .toasted {
    margin-top: 0px !important;
  }

  .error-fetching-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 50vh;
    justify-content: space-around;
  }

  .error-fetching-container .reload-btn {
    padding: 0.6rem 2rem;
    border-radius: 80px;
    background-color: rgba(0,0,0,0%);
    cursor: pointer;
    z-index: 100;    
  }

  @media (min-width: 720px) and (max-width: 768px) { 
    .show-modal-btn {
      right: 2rem;
      top: 5rem;
      position: fixed;
    }
  }

  @media (min-width: 768px) and (max-width: 896px) {
    .show-modal-btn {
      top: 5rem;
      top: unset;
    }    
  }

  @media (max-width: 768px) { 
    .show-modal-btn {
      position: fixed;
      right: 2rem;
      bottom: 4rem;
      top: unset;
    }
  }

</style>